var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app app--background-image",attrs:{"id":"cube11"}},[_c('CommingSoon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }